import { useState, useEffect, useCallback } from 'react';

export const UnloadBlocker = () => {
  const [isPaused, setIsPaused] = useState<boolean>(false);

  const handleBeforeUnload = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault();
  }, []);

  const handlePopState = useCallback(() => {
    setIsPaused(true);
  }, [setIsPaused]);

  const executeBrouwserBack = useCallback(() => {
    setIsPaused(false);
    history.back();
  }, [setIsPaused]);

  const cancelBrouwserBack = useCallback(() => {
    history.pushState(null, '', window.location.pathname);
    setIsPaused(false);
  }, [setIsPaused]);

  useEffect(() => {
    history.pushState(null, '', window.location.pathname);

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [handleBeforeUnload, handlePopState]);

  if (!isPaused) {
    return null;
  }

  return (
    <div className="absolute w-[35%] h-fit m-auto top-0 left-0 bottom-0 right-0 flex items-center justify-center bg-white border-current_key border-4 rounded-xl py-14">
      <div className="flex flex-col gap-4 items-center w-auto z-50 text-2xl font-bold">
        <img className="w-[20%] object-contain m-auto" src={`/common/attentionMark.webp`} alt={'警告'} />
        <p className="text-sub_text">タイピングをやめる？</p>
        <div className="flex item-cneter gap-4 text-white text-center">
          <span className="w-32 py-1 rounded-full bg-current_key" onClick={cancelBrouwserBack}>
            つづける
          </span>
          <span className="w-32 py-1 rounded-full bg-sub_text" onClick={executeBrouwserBack}>
            やめる
          </span>
        </div>
      </div>
    </div>
  );
};
